import _ from 'lodash';
import { Cookies } from 'react-cookie';
import {
  ERROR_UPDATE_CONFIG,
  SUCCESS_UPDATE_TEXT,
  ERROR_DELETE_DELIVERY_FEE,
  ERROR_ENABLE_FEE
} from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { updateDeliveryFee, deleteUserServicePrice } from '../../apis/shop.service';
import { showNotification } from '../Notification/Notification.view';
import {
  isDeliveryPriceInKm,
  getDriverServicePrice,
  isShopUserServicePrice
} from '../../utils/delivery';
import { openErrorModal } from '../../actions';

export const initData = async (component, isClient) => {
  const isAllShops = JSON.parse(new Cookies().get('isAllShops'));
  const servicePrice = (isClient ? isDeliveryPriceInKm() : getDriverServicePrice()) || {};
  if (isClient) {
    if ((isShopUserServicePrice() && !isAllShops) || (isDeliveryPriceInKm() && isAllShops)) {
      component.setState({ checked: true });
    } else {
      component.setState({ checked: false });
    }
  }
  if (_.size(servicePrice) > 0) {
    servicePrice.steps = !_.isEmpty(servicePrice.steps)
      ? _.map(servicePrice.steps, step => {
        return step;
      })
      : [];
  } else {
    servicePrice.perKm = { from: 0, fees: 0 };
    servicePrice.steps = [];
  }
  component.setState({
    isClient,
    servicePrice
  });
};

export const updateStepFees = ({ target }, component, step) => {
  const { servicePrice = {} } = component.state;
  const { value } = target;
  step[target.id] = parseFloat(value);
  component.setState({
    servicePrice
  });
};
export const updatePerKM = ({ target }, component) => {
  const { servicePrice = {} } = component.state;
  const { perKm = {} } = servicePrice;
  const { value } = target;
  perKm[target.id] = parseFloat(value);
  component.setState({
    servicePrice
  });
};
export const checkMinValue = ({ target }, component, step = null) => {
  let { value } = target;
  value = value !== '' ? value : 0;
  if (value <= 0) {
    target.value = 0;
  }
  if (step) updateStepFees({ target }, component, step);
  else updatePerKM({ target }, component);
};

export const submit = async (e, component) => {
  const { openErrorModal, isAllShops, shopId } = component.props;
  const { servicePrice = {}, isClient = false } = component.state;
  const { perKm, steps } = servicePrice;
  try {
    component.setState({ isLoading: true });
    const dataToFirebase = {
      perKm,
      steps: steps.filter(i => i !== undefined)
    };

    await updateDeliveryFee(dataToFirebase, isClient, isAllShops ? undefined : shopId);

    showNotification(
      'light',
      'ltr',
      'primary',
      SUCCESS_UPDATE_TEXT,
      `Les paramètres de la livraison par KM ont bien été modifiés.`
    );
  } catch (error) {
    sendCloudWatchAlert(`Error changing delivery fees ${error}`);
    openErrorModal(ERROR_UPDATE_CONFIG);
  }
  component.setState({ isLoading: false });
};

export const onChangeLayout = async (value, component) => {
  await component.setState({ isClient: value });
  await initData(component, value);
};

export const addSteps = component => {
  component.setState(prevState => {
    const newSteps = { ...prevState.servicePrice };
    const { steps = [] } = newSteps;

    steps.push({
      km: 0,
      fees: 0
    });
    return { servicePrice: newSteps };
  });
};

export const handleRemoveFees = async (stepToRemove, component) => {
  const { servicePrice } = component.state;
  const { steps } = servicePrice;
  try {
    delete steps[stepToRemove];
    component.setState({ servicePrice });
  } catch (err) {
    sendCloudWatchAlert(`Could not delete fee ${err}`);
    openErrorModal(ERROR_DELETE_DELIVERY_FEE);
  }
};

export const handleToggle = async (event, component) => {
  const { openErrorModal, isAllShops, shopId } = component.props;
  const { servicePrice = {}, isClient } = component.state;
  const isChecked = event.target.checked;
  try {
    const shouldResetDeliveryFees =
      (!isShopUserServicePrice() && !isAllShops && isChecked) ||
      (isAllShops && !isDeliveryPriceInKm());

    const updatedServicePrice = shouldResetDeliveryFees
      ? { ...servicePrice, perKm: { from: 0, fees: 0 }, steps: [] }
      : isDeliveryPriceInKm();
    component.setState({
      servicePrice: updatedServicePrice,
      checked: isChecked,
    });
    if (isChecked) {
      await updateDeliveryFee(updatedServicePrice, isClient, isAllShops ? undefined : shopId);
    } else {
      await deleteUserServicePrice(isAllShops ? undefined : shopId);
    }
    showNotification(
      'light',
      'ltr',
      'primary',
      SUCCESS_UPDATE_TEXT,
      `${isChecked ? "L'activation" : "La désactivation"} des paramètres des frais de livraison par kilomètre a été effectuée avec succès.`
    );
  } catch (error) {
    sendCloudWatchAlert(`Error enabling fees: ${error}`);
    openErrorModal(ERROR_ENABLE_FEE);
  }
};